webpackJsonp([11588923914802],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(41);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(254);
	var isArguments = __webpack_require__(253);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(49);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(48);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(110);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(109);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela;
	
	  return "<img width=" + width + " height=" + height + " src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;objectPosition:center\"/>";
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela2 = props.transitionDelay,
	      transitionDelay = _props$transitionDela2 === undefined ? "" : _props$transitionDela2,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(380);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(252);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(362);
	
	var _HelmetConstants = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(261);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(396);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fragment = undefined;
	
	var _gatsbyImage = __webpack_require__(137);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _backgroundModule = __webpack_require__(262);
	
	var _backgroundModule2 = _interopRequireDefault(_backgroundModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var resolutions = _ref.resolutions;
	  return _react2.default.createElement(_gatsbyImage2.default, { className: _backgroundModule2.default.imageWrapper,
	    outerWrapperClassName: _backgroundModule2.default.imageOuterWrapper,
	    resolutions: resolutions });
	};
	
	var fragment = exports.fragment = '** extracted graphql fragment **';

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imageOuterWrapper":"src-background----background-module---imageOuterWrapper---3CDOZ","imageWrapper":"src-background----background-module---imageWrapper---ZpAye"};

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _reactHelmet = __webpack_require__(361);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(278);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _background = __webpack_require__(182);
	
	var _background2 = _interopRequireDefault(_background);
	
	var _workpieces = __webpack_require__(184);
	
	var _workpieces2 = _interopRequireDefault(_workpieces);
	
	var _fonts = __webpack_require__(265);
	
	var _fonts2 = _interopRequireDefault(_fonts);
	
	var _indexModule = __webpack_require__(263);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _logo = __webpack_require__(398);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _logoEn = __webpack_require__(397);
	
	var _logoEn2 = _interopRequireDefault(_logoEn);
	
	var _translations = __webpack_require__(291);
	
	var _translations2 = _interopRequireDefault(_translations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var join = function join() {
	  for (var _len = arguments.length, classes = Array(_len), _key = 0; _key < _len; _key++) {
	    classes[_key] = arguments[_key];
	  }
	
	  return classes.join(' ');
	};
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'ROBERTDENIEROSTAR ',
	        pathContext.lang === 'en' ? '– English page' : ''
	      ),
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' }),
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' }),
	      _react2.default.createElement('meta', { name: 'description', content: _translations2.default[pathContext.lang].description }),
	      _react2.default.createElement('meta', { name: 'keywords', content: _translations2.default[pathContext.lang].keywords })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _indexModule2.default.sidebar },
	      _react2.default.createElement('img', { className: join(_indexModule2.default.logo, _indexModule2.default.margin),
	        src: pathContext.lang === 'de' ? _logo2.default : _logoEn2.default }),
	      _react2.default.createElement(
	        'div',
	        { className: join(_indexModule2.default.imprint, _indexModule2.default.margin) },
	        _react2.default.createElement(
	          'div',
	          { className: _indexModule2.default.address },
	          'Robert Oberzaucher',
	          _react2.default.createElement('br', null),
	          'Gro\xDFdombra 21',
	          _react2.default.createElement('br', null),
	          'A\u20139872 Millstatt',
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _indexModule2.default.contact },
	          _react2.default.createElement(
	            'a',
	            { className: _indexModule2.default.link, href: 'tel:+436641334748' },
	            '+43\u2009(0) 664 133\u200947\u200948'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { className: _indexModule2.default.link, href: 'mailto:robertdenierostar@aon.at' },
	            'robertdenierostar@aon.at'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: join(_indexModule2.default.margin, _indexModule2.default.portrait) },
	        _translations2.default[pathContext.lang].portrait,
	        _react2.default.createElement(
	          'span',
	          null,
	          ' ('
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _indexModule2.default.link,
	            exact: true,
	            to: '/' },
	          'de'
	        ),
	        '/',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _indexModule2.default.link,
	            exact: true,
	            to: '/en/' },
	          'en'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          ')'
	        )
	      ),
	      _react2.default.createElement(_workpieces2.default, { images: data.workpieces.edges.map(function (edge) {
	          return edge.node;
	        }),
	        lang: pathContext.lang })
	    ),
	    _react2.default.createElement(_background2.default, { resolutions: data.background.childImageSharp.resolutions })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contact":"src-index----index-module---contact---1d65g","imprint":"src-index----index-module---imprint---1bwZF","link":"src-index----index-module---link---2E7J_","logo":"src-index----index-module---logo---1LE1I","margin":"src-index----index-module---margin---3wq5l","portrait":"src-index----index-module---portrait---2lVHl","sidebar":"src-index----index-module---sidebar---14pwc"};

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	module.exports = {"de":{"description":"ROBERTDENIEROSTAR Metallgestaltung.","keywords":"Metallgestaltung","portrait":"Jahrgang 1973, wohnhaft am Millstätter See / Kärnten. Ausbildung zum Bauschlosser bei der Firma Tiefenböck in Spittal an der Drau. Anschließend mehrere berufliche Aufenthalte im Ausland u.a. in Deutschland, Portugal und der Schweiz. Seit 2009 als Einzelunternehmer im Bereich Metallgestaltung tätig."},"en":{"description":"ROBERTDENIEROSTAR Metalwork.","keywords":"metalwork","portrait":"Born in 1973, living by Lake Millstatt / Carinthia (Austria). Trained as a building fitter at the company Tiefenböck in Spittal by the Drave. Afterwards multiple occupational stays abroad i.a. in Germany, Portugal and Switzerland. Since 2009 working as a freelancer in the field of metalwork."}}

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	module.exports = {"Deckenaufhängung":"Ceiling mount","Dreitälerblick Höhensteig":"Dreitälerblick High Trail","Esstischgruppe":"Dining table set","Granattor Höhensteig Millstatt":"Millstatt High Trail Garnetgate","Holzkohlegriller":"Charcoal grill","Kommode":"Commode","Spieltisch":"Games table","Vordach":"Porch","Wäscheaufhängung":"Drying rack","Weinkarussell":"Wine carousel","Weinregal Ausseneckvariante":"Wine rack outer corner variant","Wohnzimmertisch":"Coffee table"}

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fragment = undefined;
	
	var _gatsbyImage = __webpack_require__(137);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _workpiecesModule = __webpack_require__(264);
	
	var _workpiecesModule2 = _interopRequireDefault(_workpiecesModule);
	
	var _translations = __webpack_require__(292);
	
	var _translations2 = _interopRequireDefault(_translations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Workpieces = function (_React$Component) {
	  _inherits(Workpieces, _React$Component);
	
	  function Workpieces(props) {
	    _classCallCheck(this, Workpieces);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleKeydown = function (event) {
	      if (_this.state.index !== null) {
	        event.preventDefault();
	
	        var index = _this.state.index;
	        var key = event.key;
	        if (key === 'Escape') {
	          _this.setState({ index: null });
	        } else if (key === 'ArrowLeft' && index > 0) {
	          _this.setState({ index: index - 1 });
	        } else if (key === 'ArrowRight' && index + 1 < _this.props.images.length) {
	          _this.setState({ index: index + 1 });
	        }
	      }
	    };
	
	    _this.state = { index: null };
	    return _this;
	  }
	
	  Workpieces.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('keydown', this.handleKeydown);
	  };
	
	  Workpieces.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('keydown', this.handleKeydown);
	  };
	
	  Workpieces.prototype.getLabel = function getLabel(node) {
	    if (!node.name) {
	      return null;
	    }
	
	    var trimmed = node.name.replace(/\d/g, '').trim();
	    return this.props.lang === 'de' ? trimmed : _translations2.default[trimmed];
	  };
	
	  Workpieces.prototype.render = function render() {
	    var _this2 = this;
	
	    var viewer = null;
	    if (this.state.index !== null) {
	      var node = this.props.images[this.state.index];
	      var aspectRatio = node.fullsize.sizes.aspectRatio;
	
	      viewer = _react2.default.createElement(
	        'div',
	        { className: _workpiecesModule2.default.viewer,
	          onClick: function onClick() {
	            return _this2.setState({ index: null });
	          } },
	        _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: '\n            .fittedWidth { width: calc((100vh - 4em) * ' + aspectRatio + '); }\n            @media (max-aspect-ratio: ' + Math.floor(aspectRatio * 1000) + '/1000) {\n              .fittedWidth { width: calc(100vw - 4em); }\n            }\n          ' } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'fittedWidth ' + _workpiecesModule2.default.viewerImageWrapper },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: node.fullsize.sizes }),
	          _react2.default.createElement(
	            'div',
	            { className: _workpiecesModule2.default.label },
	            this.getLabel(node)
	          )
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _workpiecesModule2.default.thumbnails },
	        this.props.images.map(function (node, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: _workpiecesModule2.default.thumbnailWrapper,
	              key: index,
	              onClick: function onClick() {
	                return _this2.setState({ index: index });
	              } },
	            _react2.default.createElement(_gatsbyImage2.default, { alt: _this2.getLabel(node),
	              outerWrapperClassName: _workpiecesModule2.default.thumbnail,
	              sizes: node.thumbnail.sizes,
	              title: _this2.getLabel(node) })
	          );
	        })
	      ),
	      viewer
	    );
	  };
	
	  return Workpieces;
	}(_react2.default.Component);
	
	exports.default = Workpieces;
	var fragment = exports.fragment = '** extracted graphql fragment **';

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"label":"src-workpieces----workpieces-module---label---76VYn","thumbnails":"src-workpieces----workpieces-module---thumbnails---3NNVV","thumbnailWrapper":"src-workpieces----workpieces-module---thumbnailWrapper---1EzKt","thumbnail":"src-workpieces----workpieces-module---thumbnail---2pWMu","viewer":"src-workpieces----workpieces-module---viewer---3OVKX","viewerImageWrapper":"src-workpieces----workpieces-module---viewerImageWrapper---2yCY5"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-index-index-js-b34a8efa4e9a0dbbce4c.js